import React from 'react';
import { Button, Tooltip } from '@mui/material';

const ActionButton = ({ action }) => {
    if (!action) {
        return null;
    }

    const button = (
        <Button
            variant="contained"
            startIcon={action.icon}
            onClick={action.handler}
            size="small"
            color={action?.color || 'primary'}
            disabled={action.disabled}
        >
            {action.label}
        </Button>
    );

    return action.disabled && action.tooltipText ? (
        <Tooltip title={action.tooltipText} arrow>
            <span>{button}</span>
        </Tooltip>
    ) : (
        button
    );
};

export default ActionButton;
